import { render, staticRenderFns } from "./list-table.vue?vue&type=template&id=bf471cfc&scoped=true&"
import script from "./list-table.vue?vue&type=script&lang=ts&"
export * from "./list-table.vue?vue&type=script&lang=ts&"
import style0 from "./list-table.vue?vue&type=style&index=0&id=bf471cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf471cfc",
  null
  
)

export default component.exports